import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { BaseClient, type ICropwiseBaseWorkspace } from "../utils/BaseClient";
import { getAccessToken } from "../utils/axios";

/**
 * to get workspace information for the given workspaceId
 * @param workspaceId The ID of the workspace for which to fetch the information.
 * @returns The workspace information for the specified workspace.
 */
export const useWorkspace = (
  workspaceId?: string | null
): UseQueryResult<ICropwiseBaseWorkspace> => {
  const accessToken = getAccessToken();
  return useQuery({
    queryKey: ["workspace", workspaceId, accessToken],
    enabled: !!workspaceId && !!accessToken,
    queryFn: async () => {
      const client = new BaseClient(accessToken);
      const workspace = await client.workspaceAsync(workspaceId ?? "");
      return workspace;
    },
  });
};
